define('GameDayCore/GDUtil/window/Logg',['require','exports','module','app-console/app-console'],function(require,exports,module) {
    var logger = require("app-console/app-console");

    return new logger({ ns: "GDC" });
});
